// extracted by mini-css-extract-plugin
module.exports = {"container":"Pill_container__FoIEg","small":"Pill_small__zCILo"};